module.exports = __webpack_public_path__ + "img/small_crocodile_detail.bdec8b78.png";